<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter3">
<h1 class="left"><a id="page_19"></a><a href="#/005toc#ch3"><span class="orange"><strong>CRAN-PISTACHIO</strong> COOKIES</span></a></h1>
<p class="noindent"><strong><span class="small">MAKES ABOUT 48 COOKIES</span></strong> <img alt="" class="inline" src="images/img-014.jpg"/> The red and green elements are so festive, and because of the fresh flavors of cranberries and pistachios, you’d never know that these treats, made by Kim McInnis, were made with cookie and pudding mixes.</p>
<p class="hang-space1">One 17.5-ounce pouch sugar cookie mix</p>
<p class="hang">One 3.4-ounce box pistachio instant pudding and pie filling mix</p>
<p class="hang">¼ cup all-purpose flour</p>
<p class="hang">½ cup (1 stick) unsalted butter or margarine, melted</p>
<p class="hang">2 eggs</p>
<p class="hang">1 cup dry-roasted salted pistachio nuts, chopped</p>
<p class="hang">½ cup dried cranberries, chopped</p>
<p class="noindent-space1"><strong><span class="small">PREHEAT</span></strong> the oven to 350°F.</p>
<p class="noindent-space1"><strong><span class="small">IN</span></strong> a large bowl, stir together the cookie mix, pudding mix, and flour. Stir in the butter and eggs until a soft dough forms. Add the pistachios and cranberries; mix well.</p>
<p class="noindent-space1"><strong><span class="small">DROP</span></strong> portions of the dough, using a small cookie scoop or heaping teaspoon, 2 inches apart on ungreased cookie sheets. Press each scoop with your fingers to slightly flatten it.</p>
<p class="noindent-space1"><strong><span class="small">BAKE</span></strong> 9 to 11 minutes, or until the edges are a light golden brown. Let cool for 2 minutes, then remove the cookies to a wire rack. Cool completely. Store tightly covered at room temperature for about 1 week.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010chapter3.vue?5a9f0afc